/* Art Boutiki — theme.js  (vanilla, no dependencies) */
(function () {
  "use strict";

  /* ---------- Mobile nav ---------- */
  const menuToggle = document.querySelector("[data-menu-toggle]");
  const mobileNav = document.querySelector("[data-mobile-nav]");
  const scrim = document.querySelector("[data-scrim]");
  function closeMenu() {
    mobileNav && mobileNav.classList.remove("is-open");
    scrim && scrim.classList.remove("is-open");
    document.body.style.overflow = "";
  }
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener("click", function () {
      const open = mobileNav.classList.toggle("is-open");
      scrim && scrim.classList.toggle("is-open", open);
      document.body.style.overflow = open ? "hidden" : "";
    });
  }
  scrim && scrim.addEventListener("click", closeMenu);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeMenu(); });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener("click", function (e) {
    const btn = e.target.closest("[data-qty]");
    if (!btn) return;
    const input = btn.parentElement.querySelector("input");
    if (!input) return;
    let v = parseInt(input.value, 10) || 1;
    v += btn.dataset.qty === "up" ? 1 : -1;
    input.value = Math.max(1, v);
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });

  /* ---------- Product gallery thumbnails ---------- */
  const gallery = document.querySelector("[data-gallery]");
  if (gallery) {
    const main = gallery.querySelector("[data-gallery-main] img");
    gallery.querySelectorAll("[data-thumb]").forEach(function (t) {
      t.addEventListener("click", function () {
        if (!main) return;
        main.src = t.dataset.full || t.querySelector("img").src;
        gallery.querySelectorAll("[data-thumb]").forEach(function (x) { x.classList.remove("is-active"); });
        t.classList.add("is-active");
      });
    });
  }

  /* ---------- Cart count helper ---------- */
  function updateCartCount(count) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = count;
      el.classList.toggle("hide", count === 0);
    });
  }

  /* ---------- AJAX add to cart ---------- */
  document.addEventListener("submit", function (e) {
    const form = e.target.closest("[data-product-form]");
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector("[type=submit]");
    const original = btn ? btn.textContent : "";
    if (btn) { btn.textContent = "Adding…"; btn.disabled = true; }

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(serialize(form)),
    })
      .then(function (r) { return r.json(); })
      .then(function () { return fetch("/cart.js").then(function (r) { return r.json(); }); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        if (btn) { btn.textContent = "Added ✓"; setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1600); }
        openCartDrawer(cart);
      })
      .catch(function () {
        if (btn) { btn.textContent = original; btn.disabled = false; }
        window.location.href = "/cart";
      });
  });

  function serialize(form) {
    const data = { items: [] };
    const id = form.querySelector("[name=id]");
    const qty = form.querySelector("[name=quantity]");
    data.items.push({ id: id ? id.value : null, quantity: qty ? parseInt(qty.value, 10) || 1 : 1 });
    return data;
  }

  /* ---------- Lightweight cart drawer ---------- */
  function openCartDrawer(cart) {
    let drawer = document.querySelector("[data-cart-drawer]");
    if (!drawer) {
      drawer = document.createElement("div");
      drawer.setAttribute("data-cart-drawer", "");
      drawer.innerHTML =
        '<div class="cart-drawer__scrim" data-cart-close></div>' +
        '<aside class="cart-drawer__panel" role="dialog" aria-label="Cart"></aside>';
      document.body.appendChild(drawer);
      injectDrawerStyles();
      drawer.addEventListener("click", function (e) {
        if (e.target.closest("[data-cart-close]")) drawer.classList.remove("is-open");
      });
    }
    const panel = drawer.querySelector(".cart-drawer__panel");
    const money = function (c) { return "$" + (c / 100).toFixed(2); };
    let lines = "";
    cart.items.forEach(function (it) {
      lines +=
        '<div class="cart-drawer__line">' +
        '<img src="' + (it.image || "") + '" alt="" width="64" height="64">' +
        '<div><a href="' + it.url + '">' + it.product_title + "</a>" +
        (it.variant_title && it.variant_title !== "Default Title" ? '<small>' + it.variant_title + "</small>" : "") +
        '<div class="cart-drawer__q">Qty ' + it.quantity + " · " + money(it.final_line_price) + "</div></div></div>";
    });
    panel.innerHTML =
      '<div class="cart-drawer__head"><strong>Your bag (' + cart.item_count + ')</strong>' +
      '<button data-cart-close aria-label="Close">✕</button></div>' +
      '<div class="cart-drawer__lines">' + (lines || "<p style=padding:24px>Your bag is empty.</p>") + "</div>" +
      '<div class="cart-drawer__foot"><div class="cart-drawer__sub"><span>Subtotal</span><strong>' +
      money(cart.total_price) + "</strong></div>" +
      '<a href="/cart" class="btn btn--ghost btn--block" style="margin-bottom:10px">View bag</a>' +
      '<a href="/checkout" class="btn btn--block">Checkout</a></div>';
    requestAnimationFrame(function () { drawer.classList.add("is-open"); });
  }

  function injectDrawerStyles() {
    if (document.getElementById("cart-drawer-css")) return;
    const s = document.createElement("style");
    s.id = "cart-drawer-css";
    s.textContent =
      "[data-cart-drawer]{position:fixed;inset:0;z-index:120;visibility:hidden}" +
      "[data-cart-drawer].is-open{visibility:visible}" +
      ".cart-drawer__scrim{position:absolute;inset:0;background:rgba(20,16,12,.45);opacity:0;transition:opacity .3s}" +
      "[data-cart-drawer].is-open .cart-drawer__scrim{opacity:1}" +
      ".cart-drawer__panel{position:absolute;top:0;right:0;height:100%;width:min(92vw,420px);background:var(--bg);display:flex;flex-direction:column;transform:translateX(100%);transition:transform .35s cubic-bezier(.22,1,.36,1);box-shadow:var(--shadow)}" +
      "[data-cart-drawer].is-open .cart-drawer__panel{transform:none}" +
      ".cart-drawer__head{display:flex;justify-content:space-between;align-items:center;padding:22px 24px;border-bottom:1px solid var(--line);font-family:var(--font-head);font-size:1.1rem}" +
      ".cart-drawer__head button{background:none;border:0;font-size:1.1rem}" +
      ".cart-drawer__lines{flex:1;overflow-y:auto;padding:8px 24px}" +
      ".cart-drawer__line{display:grid;grid-template-columns:64px 1fr;gap:14px;padding:16px 0;border-bottom:1px solid var(--line);align-items:center}" +
      ".cart-drawer__line img{border-radius:10px;object-fit:cover;border:1px solid var(--line)}" +
      ".cart-drawer__line a{font-family:var(--font-head);font-weight:500;font-size:.95rem}" +
      ".cart-drawer__line small{display:block;color:var(--ink-soft);font-size:.8rem}" +
      ".cart-drawer__q{font-size:.85rem;color:var(--ink-soft);margin-top:4px}" +
      ".cart-drawer__foot{padding:20px 24px;border-top:1px solid var(--line)}" +
      ".cart-drawer__sub{display:flex;justify-content:space-between;margin-bottom:16px;font-family:var(--font-head);font-size:1.05rem}";
    document.head.appendChild(s);
  }
})();
